var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clear",
    viewBox: "0 0 18 18",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99994 16.5C13.1421 16.5 16.4999 13.1421 16.4999 9C16.4999 4.85786 13.1421 1.5 8.99994 1.5C4.8578 1.5 1.49994 4.85786 1.49994 9C1.49994 13.1421 4.8578 16.5 8.99994 16.5ZM8.99994 18C13.9705 18 17.9999 13.9706 17.9999 9C17.9999 4.02944 13.9705 0 8.99994 0C4.02938 0 -6.10352e-05 4.02944 -6.10352e-05 9C-6.10352e-05 13.9706 4.02938 18 8.99994 18ZM5.53016 5.63635C5.82305 5.34345 6.29792 5.34345 6.59082 5.63635L8.97715 8.02268L11.4695 5.53034C11.7624 5.23745 12.2373 5.23745 12.5302 5.53034C12.823 5.82323 12.823 6.29811 12.5302 6.591L10.0378 9.08334L12.5302 11.5757C12.823 11.8686 12.823 12.3435 12.5302 12.6363C12.2373 12.9292 11.7624 12.9292 11.4695 12.6363L8.97715 10.144L6.59082 12.5303C6.29792 12.8232 5.82305 12.8232 5.53016 12.5303C5.23726 12.2374 5.23726 11.7626 5.53016 11.4697L7.91649 9.08334L5.53016 6.69701C5.23726 6.40412 5.23726 5.92924 5.53016 5.63635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.52a83fdd713a9ca3702c729184d0ed64.svg";
export { ForwardRef as ReactComponent };